export default __webpack_public_path__ + "static/media/bg6.4976cc1c.jpg";